import { render, staticRenderFns } from "./ChapterCard.vue?vue&type=template&id=c71722e0&scoped=true"
import script from "./ChapterCard.vue?vue&type=script&lang=js"
export * from "./ChapterCard.vue?vue&type=script&lang=js"
import style0 from "./ChapterCard.vue?vue&type=style&index=0&id=c71722e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71722e0",
  null
  
)

export default component.exports